import React, { useContext } from 'react';
import { useSelector } from 'react-redux';

import { ConditionalRendering } from '@components/common/conditional-rendering';
import Tooltip from '@components/common/tooltip/Tooltip';
import { usePermissions } from '@hooks/usePermissions';
import { getCurrency } from '@utils/tools/currencyTools';
import { IEnrollmentPremiumDto } from '../../common/types';
import { EnrollmentContext } from '../../context/MemberMyEnrollmentProvider';

const ColumnGrossPremium = ({ premium }: { premium: IEnrollmentPremiumDto }) => {
    const permissions = useSelector((state: any) => state.memberEnrollment?.permissions);
    const { userPermissions } = permissions || {};
    const {
        viewEditableFields,
        isNotApplicable,
        isPendingCalculation,
        isPremiumMonthInOrignalEffectiveDate,
        isPremiumMonthNotInOrignalEffectiveDate,
    } = usePermissions();
    const { enrollmentPremiumFormContext, selectedEnrollment } = useContext(EnrollmentContext);
    const { watch } = enrollmentPremiumFormContext;
    const values = watch();

    return (
        <>
            <ConditionalRendering isTrue={!isNotApplicable(premium, values)}>
                <Tooltip
                    id="member.enrollment_list.premiumhistory.notApplicable"
                    elementId="premiumhistory"
                    content="member.enrollment_list.premiumhistory.notApplicable.popup"
                    place="top"
                    dataAutomationId="premiumhistory"
                    data-testid="notApplicable"
                />
            </ConditionalRendering>
            <ConditionalRendering isTrue={isNotApplicable(premium, values)}>
                <ConditionalRendering isTrue={isPremiumMonthInOrignalEffectiveDate(premium.month)}>
                    {getCurrency(premium.grossPremiumAmount)}
                </ConditionalRendering>
                <ConditionalRendering isTrue={isPremiumMonthNotInOrignalEffectiveDate(premium.month)}>
                    <Tooltip
                        id="member.enrollment_list.premiumhistory.pendingCalculation"
                        elementId="pendingCalculation"
                        content="member.enrollment_list.premiumhistory.pendingCalculation.popup"
                        place="top"
                        dataAutomationId="pendingCalculation"
                        data-testid="pendingCalculation"
                    />
                </ConditionalRendering>
            </ConditionalRendering>
        </>
    );
};

export default ColumnGrossPremium;
